import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";

// Custom toolbar including our token button
export const AutoRuleToolbar = () => {
  const [t] = useTranslation();
  return (
    <div id="toolbar">
      <span className="ql-formats">
        <button className="ql-bold ql-btn" />
        <button className="ql-italic ql-btn" />
        <button className="ql-underline ql-btn" />
      </span>
      <span className="ql-formats">
        <button className="ql-list ql-btn" value="ordered" />
        <button className="ql-list ql-btn" value="bullet" />
      </span>
      <span className="ql-formats">
        <button className="ql-link ql-btn" />
      </span>
      <span className="ql-formats">
        <OverlayTrigger
          placement="auto"
          overlay={(props) => (
            <Tooltip id="master-toggle-tooltip" {...props}>
              {t("versionsForm.autorule.delimeterBtnInfo")}
            </Tooltip>
          )}
        >
          <button id="insert-rule-delimeter" className="ql-rule-delimeter">
            {t("versionsForm.autorule.delimeterBtn")}
          </button>
        </OverlayTrigger>
      </span>
    </div>
  );
};
